import '../css/shared/blocks/gallery.css';

async function initGalleries() {
    const galleries = document.querySelectorAll('.simplegallery');

    // Guard clause: stop if no galleries exist on the page
    if (!galleries.length) return;

    // Dynamically load libraries and CSS only when galleries exist
    const [
        { default: Swiper },
        { Navigation, Thumbs },
        { default: SimpleLightbox }
    ] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
        import('simplelightbox'),
        import('swiper/css'),
        import('swiper/css/thumbs'),
        import('simplelightbox/dist/simple-lightbox.css')
    ]);

    galleries.forEach((gallery) => {
        const swiperElement = gallery.querySelector('.simplegallery-swiper');
        const thumbSwiperElement = gallery.querySelector('.simplegallery-thumbs');

        // Ensure both swiper elements exist before initializing
        if (!swiperElement || !thumbSwiperElement) return;

        // Initialize Thumbnail Swiper
        const thumbSwiper = new Swiper(thumbSwiperElement, {
            modules: [Thumbs],
            slidesPerView: 8,
            freeMode: true,
            watchSlidesProgress: true,
        });

        // Initialize Main Swiper
        new Swiper(swiperElement, {
            modules: [Navigation, Thumbs],
            slidesPerView: 1,
            loop: true,
            thumbs: {
                swiper: thumbSwiper,
            },
            navigation: {
                nextEl: gallery.querySelector('.swiper-button-next'),
                prevEl: gallery.querySelector('.swiper-button-prev'),
            },
        });

        // Initialize Lightbox scoped to the current gallery container
        new SimpleLightbox(swiperElement.querySelectorAll('a.swiper-slide'), {
            /* options */
        });
    });
}

// Execute initialization
initGalleries();